
function KontaktFormular() {
    return (
        <div className="KontaktFormular">
            <form>

            <input type="email" placeholder="Email">
                </input>

                <input type="text" placeholder="Anfrage">
                </input>
            </form>
        </div>
    );
}

export default KontaktFormular;